import { render } from "./seoView.vue?vue&type=template&id=6b9b4e4d&scoped=true"
import script from "./seoView.vue?vue&type=script&lang=js"
export * from "./seoView.vue?vue&type=script&lang=js"

import "./seoView.vue?vue&type=style&index=0&id=6b9b4e4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9b4e4d"]])

export default __exports__